import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import FactoryManagementService from "../api/factoryManagementService";
import { factoryManagementActions } from "../reducers/factory-management";

function* getFactoriesListData({ payload }: any): any {
  const res = yield call(FactoryManagementService.fetchFactoriesList, payload);
  if (res.status === "success") {
    yield put(factoryManagementActions.getFactoriesListResponse(res.res));
  } else {
    yield put(factoryManagementActions.getFactoriesListFailed(res?.code));
  }
}

function* getFactoryData({ payload }: any): any {
  const res = yield call(
    FactoryManagementService.fetchFactory,
    payload.factoryId ? payload.factoryId : payload,
  );
  if (res.status === "success") {
    yield put(factoryManagementActions.getFactoryDataResponse(res.res));
  } else {
    yield put(factoryManagementActions.getFactoryDataFailed(res?.code));
  }
}

function* addNewFactory({ payload }: any): any {
  const res = yield call(FactoryManagementService.addFactory, payload);
  if (res.status === "success") {
    yield put(factoryManagementActions.addFactoryResponse(res.code));
  } else {
    yield put(factoryManagementActions.addFactoryFailed(res?.code));
  }
}

function* updateFactory({ payload }: any): any {
  const res = yield call(
    FactoryManagementService.updateFactory,
    payload.data ? payload.data : payload,
  );
  if (res.status === "success") {
    yield put(factoryManagementActions.updateFactoryResponse(res.code));
  } else {
    yield put(factoryManagementActions.updateFactoryFailed(res?.code));
  }
}

function* updateFactoryStatus({ payload }: any): any {
  const res = yield call(FactoryManagementService.updateFactoryStatus, payload);
  if (res.status === "success") {
    yield put(factoryManagementActions.updateFactoryStatusResponse(res.code));
  } else {
    yield put(factoryManagementActions.updateFactoryStatusFailed(res?.code));
  }
}

function* removeFactory({ payload }: any): any {
  const res = yield call(FactoryManagementService.removeFactory, payload);
  if (res.status === "success") {
    yield put(factoryManagementActions.removeFactoryResponse(res.code));
  } else {
    yield put(factoryManagementActions.removeFactoryFailed(res?.code));
  }
}

function* getAssetComponentsData({ payload }: any): any {
  const res = yield call(
    FactoryManagementService.fetchAssetComponents,
    payload,
  );
  if (res.status === "success") {
    yield put(factoryManagementActions.getAssetComponentsDataResponse(res.res));
  } else {
    yield put(factoryManagementActions.getAssetComponentsDataFailed(res?.code));
  }
}

function* getAssetComponentsDataBatch({ payload }: any): any {
  const res = yield call(FactoryManagementService.fetchAssetsConfig, {
    asset_ids: payload,
  });
  if (res.status === "success") {
    yield put(
      factoryManagementActions.getAssetComponentsDataBatchResponse(res.res),
    );
  } else {
    yield put(
      factoryManagementActions.getAssetComponentsDataBatchFailed(res?.code),
    );
  }
}

function* scanForTags({ payload }: any): any {
  const res = yield call(FactoryManagementService.scanTagsApiCall, payload);
  if (res.status === "success") {
    yield put(factoryManagementActions.scanTagsResponse(res.res));
  } else {
    yield put(factoryManagementActions.scanTagsFailed(res));
  }
}

function* getCopyConfigurationFromList({ payload }: any): any {
  const res = yield call(
    FactoryManagementService.fetchCopyConfigurationFromList,
    payload,
  );
  if (res.status === "success") {
    yield put(
      factoryManagementActions.getCopyConfigurationFromListResponse(res.res),
    );
  } else {
    yield put(
      factoryManagementActions.getCopyConfigurationFromListFailed(res?.code),
    );
  }
}

function* getCopyConfigurationFromComponent({ payload }: any): any {
  const res = yield call(
    FactoryManagementService.fetchCopyConfigurationFromComponent,
    payload,
  );
  if (res.status === "success") {
    yield put(
      factoryManagementActions.getCopyConfigurationFromComponentResponse(
        res.res,
      ),
    );
  } else {
    yield put(
      factoryManagementActions.getCopyConfigurationFromComponentFailed(
        res?.code,
      ),
    );
  }
}

function* FactoryManagementSaga() {
  yield takeLatest("factoryManagement/getFactoriesList", getFactoriesListData);
  yield takeLeading("factoryManagement/getFactoryData", getFactoryData);
  yield takeLeading("factoryManagement/addFactoryRequest", addNewFactory);
  yield takeLeading("factoryManagement/updateFactoryRequest", updateFactory);
  yield takeLeading(
    "factoryManagement/updateFactoryStatusRequest",
    updateFactoryStatus,
  );
  yield takeLeading("factoryManagement/removeFactoryRequest", removeFactory);
  yield takeLeading(
    "factoryManagement/getAssetComponentsDataRequest",
    getAssetComponentsData,
  );
  yield takeLeading(
    "factoryManagement/getAssetComponentsDataBatchRequest",
    getAssetComponentsDataBatch,
  );
  yield takeLatest("factoryManagement/scanTagsRequest", scanForTags);
  yield takeLatest(
    "factoryManagement/getCopyConfigurationFromListRequest",
    getCopyConfigurationFromList,
  );
  yield takeLatest(
    "factoryManagement/getCopyConfigurationFromComponentRequest",
    getCopyConfigurationFromComponent,
  );
}

export default FactoryManagementSaga;
